export { isValidEnvironment, AccountEnvironment }

/**
 * Checks if the given environment is valid.
 *
 * @param {string | string[]} env - The environment to check, if an array of
 *   strings will only check the first value
 * @returns {boolean} True if the environment is either 'test' or 'prod', false
 *   otherwise.
 */
function isValidEnvironment(env) {
  const [first] = [env].flat()
  return [AccountEnvironment.PROD, AccountEnvironment.TEST].includes(first)
}

/** @enum {'test' | 'prod'} */
const AccountEnvironment = /** @type {const} */ ({
  TEST: 'test',
  PROD: 'prod',
})
